export default __webpack_public_path__ + "static/media/PlocastaKomoraHladnjak.f9e081df.png";